import _ from 'lodash'

const isProd = process.env.VUE_APP_ENV === 'production'

import livingOptionsJson from '../../json/living-options.json'
import subsectionsJson from '../../json/subsections.json'
import propertiesJson from '../../json/properties.json'
import propertyModelsJson from '../../json/property-models.json'

export default {
  namespaced: true,
  state: {
    livingOptions: isProd ? livingOptionsJson : [],
    subsections: isProd ? subsectionsJson : [],
    properties: isProd ? propertiesJson : [],
    propertyModels: isProd ? propertyModelsJson : [],

    inputType: null,
    inputBeds: false,
    inputBaths: false,
    inputCars: false,
  },

  mutations: {
    SET_LIVING_OPTIONS (state, livingOptions) {
      state.livingOptions = livingOptions
    },

    SET_SUBSECTIONS (state, subsections) {
      state.subsections = subsections
    },

    SET_PROPERTIES (state, properties) {
      state.properties = properties
    },

    SET_PROPERTY_MODELS (state, propertyModels) {
      state.propertyModels = propertyModels
    },    

    SET_FILTER_PARAMETERS: (state, parameters) => {
      if (!_.isUndefined(parameters.inputType)) state.inputType = parameters.inputType
      if (!_.isUndefined(parameters.inputBeds)) state.inputBeds = parameters.inputBeds
      if (!_.isUndefined(parameters.inputBaths)) state.inputBaths = parameters.inputBaths
      if (!_.isUndefined(parameters.inputCars)) state.inputCars = parameters.inputCars
    },    

    RESET_FILTER_PARAMETERS: state => {
      state.inputType = null
      state.inputBeds = false
      state.inputBaths = false
      state.inputCars = false
    },
  },

  getters: {
    activeLivingOption: (state, getters, rootState) => {
      if (rootState.route.params.livingOptionId) {
        return _.find(getters.livingOptions, livingOption => {
          return livingOption._id === rootState.route.params.livingOptionId
        })
      } else {
        return null
      }
    },

    activeModel: (state, getters) => {
      if (getters.activeProperty) {
        return _.find(state.propertyModels, model => {
          return model._id === getters.activeProperty.modelId
        })
      } else {
        return null
      }
    },

    activeProperty: (state, getters, rootState) => {
      if (rootState.route.params.propertyId) {
        return _.find(getters.properties, property => {
          return property._id === rootState.route.params.propertyId
        })
      } else {
        return null
      }
    },

    activeSubsection: (state, getters, rootState) => {
      if (rootState.route.params.livingOptionId && rootState.route.params.livingOptionId) {
        return _.find(getters.activeLivingOption.subsections, subsection => {
          return subsection._id === rootState.route.params.subsectionId
        })
      } else {
        return null
      }
    },

    livingOptions: (state, getters) => {
      if (getters.subsections.length && getters.properties.length) {
        let livingOptions = JSON.parse(JSON.stringify(state.livingOptions))

        // filter out if isEnabled true
        livingOptions = _.filter(livingOptions, livingOption => { return livingOption.isEnabled })

        livingOptions.forEach(livingOption => {
          // Add propertyTypes and properties TODO: Move server side
          let propertyTypes = []
          let propertyIds = []
          let properties = []
          livingOption.matchedPropertiesCount = 0
          livingOption.subsectionIds.forEach(subsectionId => {
            const subsection = _.find(getters.subsections, subsection => {
              return subsection._id === subsectionId
            })
            if (subsection) {
              propertyIds.push(...subsection.propertyIds)
            }
          })
          livingOption.propertyIds = propertyIds
          if (livingOption.propertyIds) {
            livingOption.propertyIds.forEach(propertyId => {
              const property = _.find(getters.properties, property => { return property._id === propertyId })
              if (property) {
                properties.push(property)
                property.models.forEach(model => {
                  propertyTypes.push(model.type)
                })
              } 
            })
          }
          livingOption.propertyTypes = _.uniq(propertyTypes)
          livingOption.properties = properties

          let subsections = []
          let filter = true
          livingOption.subsectionIds.forEach(subsectionId => {
            const subsection = _.find(getters.subsections, subsection => { return subsection._id === subsectionId })
            if (subsection) {
              livingOption.matchedPropertiesCount += subsection.matchedPropertiesCount
              subsections.push(subsection)
              if (subsection.filter === false) {
                filter = false
              }
            }
          })
          livingOption.subsections = subsections
          livingOption.filter = filter
        })
        return livingOptions
      } else {
        return []
      }
    },

    // Adds some attributes to the raw list of properies, specifically: assigns the model object and filtered state
    properties: state => {
      if (state.propertyModels.length) {
        let properties = JSON.parse(JSON.stringify(state.properties))

        properties.forEach(property => {
          // Push the associated property models into property.models
          property.models = _.filter(state.propertyModels, model => {
            return property.modelIds.includes(model._id)
          })

          if (property.models.length) {
            property.filter =  false

            property.models.forEach(model => {
              const beds = parseInt(model.beds) > 4 ? 4 : parseInt(model.beds)
              const baths = model.baths > 4 ? 4 : model.baths
              const cars = model.cars > 4 ? 4 : model.cars
              const type = model.type.toLowerCase() === 'terrace' ? 'house' : model.type.toLowerCase() // turn all terraces into houses for filtering purposes

              if (state.inputType && state.inputType !== type) {
                property.filter =  true

              } else if (state.inputBaths && state.inputBaths !== baths) {
                // No bathroom data
                // property.filter =  true
              
              } else if ((state.inputBeds || state.inputBeds === 0) && state.inputBeds !== beds) {
                property.filter =  true

              } else if (state.inputCars && state.inputCars !== cars) {
                // No car data
                // property.filter =  true
              }
            })
          }

          // TODO filter by status
          if (property.status !== "For Sale") {
            property.filter = true
          }
        })
        return properties
      } else {
        return []
      }
    },

    propertyTypes: state => {
      let types = []
      state.propertyModels.forEach(propertyModel => {
        let propertyModelType = propertyModel.type.toLowerCase()
        if (propertyModelType === 'terrace' || propertyModelType === 'house') {
          types.push('house')
        } else {
          types.push(propertyModelType)
        }
      })
      return _.uniq(types)
    },

    // Returns an array of Subsection objects with their associated Properties nested inside
    // Also sets a "filter" flag to true if all properties have been filtered out
    // Also handles nested subsections
    subsections: (state, getters) => {
      if (getters.properties.length) {
      // Clone subsections from state
        let subsections = JSON.parse(JSON.stringify(state.subsections))

        // filter out if isEnabled true
        subsections = _.filter(subsections, subsection => { return subsection.isEnabled })

        // Next associated properties
        subsections.forEach(subsection => {
          subsection.matchedPropertiesCount = 0
          let properties = []
          let filter = true
          subsection.propertyIds.forEach(propertyId => {
            const property = _.find(getters.properties, property => { return property._id === propertyId })
            if (property) {
              properties.push(property)
              if (property.filter === false) {
                subsection.matchedPropertiesCount++
                filter = false
              }
            }
          })
          subsection.properties = properties
          // Set filter based on properties filter value (if at least 1 property isn't filtered, then dont filter)
          subsection.filter = filter

          // Nest assicated subsections
          if (subsection.subsectionIds && subsection.subsectionIds.length) {
            subsection.subsections = []
            subsection.subsectionIds.forEach(subsectionId => {
              const subSubsection = _.find(subsections, subsection => { return subsection._id === subsectionId })
              subsection.subsections.push(subSubsection)
            })
          }
        })
        return subsections
      } else {
        return []
      }
    }
  }
}
